export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14766.064c291a.jpg";